import { api } from 'utils/utils-api';

export const apiUrl = `${process.env.SAS_API_URL}/api/v3`;

export const getDsps = () => {
  return api
    .get(`${apiUrl}/dsps`)
    .then(response => {
      return response;
    })
    .catch(error => Promise.reject(error));
};
